import { get } from "../../api/axios"
import endpoints from "../../api/endpoints"

/** Matches City Hub Arts Genome donut (genome-donut.svg). */
export const GENOME_DONUT_TRACK = "#E9D5E8"

const CLASS_COLORS = {
  creator: "#6EE7B7",
  organizer: "#A78BFA",
  supporter: "#F6B9A4",
}

const SPELLBOOK_COLORS = {
  music: "#A78BFA",
  film: "#F6B9A4",
  "visual arts": "#6EE7B7",
  "performing arts": "#E9A3C9",
  literary: "#93C5FD",
}

const FALLBACK_COLORS = ["#A78BFA", "#F6B9A4", "#6EE7B7", "#E9A3C9", "#93C5FD"]

const mapSummary = (result = {}, colors = {}, fallbackLabel = "Item") => {
  const summary = Array.isArray(result.summary) ? result.summary : []
  return summary
    .map((item, index) => {
      const label = item?.name || fallbackLabel
      const key = String(label).trim().toLowerCase()
      return {
        id: item?.id || `${key}-${index}`,
        label,
        value: Math.round(Number(item?.percentage) || 0),
        count: Number(item?.count) || 0,
        color: colors[key] || FALLBACK_COLORS[index % FALLBACK_COLORS.length],
      }
    })
    .filter(item => item.value > 0 || item.count > 0)
}

export const genomeConicGradient = (items = []) => {
  let cursor = 0
  const stops = items.map(item => {
    const start = cursor
    cursor += Number(item.value) || 0
    return `${item.color} ${start}% ${cursor}%`
  })
  if (cursor < 100) {
    stops.push(`${GENOME_DONUT_TRACK} ${cursor}% 100%`)
  }
  return `conic-gradient(${stops.join(", ")})`
}

const fetchSummary = async (endpoint, mapper, userId) => {
  if (!userId) return []
  try {
    const response = await get(endpoint(userId))
    if (!response?.data?.success) return []
    return mapper(response.data.result)
  } catch {
    return []
  }
}

export const mapClassSummary = result =>
  mapSummary(result, CLASS_COLORS, "Role")

export const mapSpellbookSummary = result =>
  mapSummary(result, SPELLBOOK_COLORS, "Genre")

export const fetchClassSummary = userId =>
  fetchSummary(endpoints.getUserClassSummary, mapClassSummary, userId)

export const fetchSpellbookSummary = userId =>
  fetchSummary(endpoints.getUserSpellbookSummary, mapSpellbookSummary, userId)

export const fetchCitySpellbookSummary = cityId =>
  fetchSummary(endpoints.getCitySpellbookSummary, mapSpellbookSummary, cityId)
